export default __webpack_public_path__ + "static/media/cs-gif3.1c868b3d.gif";